import {useEffect, useState} from "react";
import {AccountsAPI} from "../../accounts-api/accounts-api";
import {isDev} from "../../env/env";

const devAvatar = "https://images.wakelet.com/resize?id=a92fb6ed-43f2-43c7-9d28-5a6ace66da79&h=150&w=150&q=85"
export type useLoadAvatarUrlReturn = {
    avatarUrl: string | undefined;
    isLoading: boolean;
    isError: boolean;
}

export const useLoadAvatarUrl = (email?: string): useLoadAvatarUrlReturn => {
    const shouldLoadAvatar = !!email;
    const [avatarUrl, setAvatarUrl] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(shouldLoadAvatar);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        if (shouldLoadAvatar) {
            AccountsAPI.getAvatar(email)
                .then(avatarUrl => {
                    if (isDev()) {
                        setAvatarUrl(devAvatar)
                    } else {
                        setAvatarUrl(avatarUrl);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setIsError(true);
                    setIsLoading(false);
                });
        }
    }, []);

    return {
        avatarUrl,
        isError,
        isLoading,
    }
}
